import React, { useEffect, useState } from "react";
import { teamHistory } from "../../utils/enum/enums";
import { sortByText } from "../../utils/sort/sort";
import { useSelector } from "react-redux";
import { IsAllow } from "../../utils/allowHelper/AllowHelper";
import { useTranslator } from "../../context/translator";
import { useGetCompanyQuery, useGetUserByIdQuery } from "store/api/apiSlice";

const TeamSearch = ({ agents, setAgent, type, setType }) => {
  const { user } = useSelector((state) => state.user);
  const [companyAllow, setCompanyAllow] = useState([]);

  const { data: userProfile, isLoading: userLoading } = useGetUserByIdQuery(
    user.id,
    {
      skip: !user?.id,
      pollingInterval: 60000,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    },
  );

  const { data: company, isLoading: companyLoading } = useGetCompanyQuery(
    userProfile?.user?.companyId,
    {
      skip: !userProfile?.user?.companyId,
    },
  );

  const { translate } = useTranslator();

  const [options] = useState(() =>
    sortByText([
      { id: teamHistory.ALL, text: translate("all") },
      { id: teamHistory.CALL, text: translate("call") },
      { id: teamHistory.MESSAGE, text: translate("message") },
      { id: teamHistory.EMAIL, text: "Email" },
      { id: teamHistory.DEPOSIT, text: translate("deposit") },
      { id: teamHistory.COMMENT, text: translate("comment") },
      { id: teamHistory.LOGIN, text: "Login" },
      { id: teamHistory.NEWUSER, text: translate("new-user") },
    ]),
  );

  const handleTypeChange = (e) => setType(e.target.value);
  const handleAgentChange = (e) => setAgent(e.target.value);

  useEffect(() => {
    if (company?.allow) {
      setCompanyAllow({ ...company.allow });
    }
  }, [company]);

  if (userLoading || companyLoading) return null;

  return (
    <form className="grid gap-6 mb-6 md:grid-cols-2">
      <div>
        <label
          htmlFor="type"
          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
        >
          {translate("filter-type")}
        </label>
        <select
          id="type"
          value={type}
          onChange={handleTypeChange}
          className="p-4 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg 
                     focus:ring-blue-500 focus:border-blue-500 block w-full 
                     dark:bg-gray-700 dark:border-gray-600 dark:text-white"
        >
          {options.map((option) => {
            if (
              option.id === teamHistory.DEPOSIT &&
              !IsAllow(companyAllow, "SBFields")
            )
              return null;
            return (
              <option key={option.id} value={option.id}>
                {option.text}
              </option>
            );
          })}
        </select>
      </div>

      <div>
        <label
          htmlFor="users"
          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
        >
          {translate("filter-employee")}
        </label>
        <select
          id="users"
          defaultValue="all"
          onChange={handleAgentChange}
          className="p-4 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg 
                     focus:ring-blue-500 focus:border-blue-500 block w-full 
                     dark:bg-gray-700 dark:border-gray-600 dark:text-white"
        >
          <option value="all">{translate("all-employees")}</option>
          {agents?.map((agent) => (
            <option key={agent._id} value={agent.ext}>
              {agent.firstName} {agent.lastName}
            </option>
          ))}
        </select>
      </div>
    </form>
  );
};

export default TeamSearch;
